import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'

import {
  BalanceBenefitCellComponent,
  BalanceBenefitCellFormat,
} from '../balance-benefit-cell/balance-benefit-cell.component'

@Component({
  selector: 'tr[mmxBalanceBenefitRow]',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, BalanceBenefitCellComponent],
  templateUrl: './balance-benefit-row.component.html',
  styleUrls: ['./balance-benefit-row.component.scss'],
  host: {
    class: 'balance-benefit-row mat-mdc-row',
    'data-balance-benefit-row': '',
  },
})
export class BalanceBenefitRowComponent {
  @Input({ required: true }) labelKey!: string
  @Input({ required: true }) primaryControl!: FormControl<number | null>
  @Input() secondaryControl: FormControl<number | null> | null = null
  @Input() format: BalanceBenefitCellFormat = 'currency'
  @Input() originalPrimary: number | null = null
  @Input() originalSecondary: number | null = null
  @Input() ambiguousPrimary = false
  @Input() ambiguousSecondary = false
  @Input() hasSecondary = false

  @Output() readonly committed = new EventEmitter<void>()

  onCellCommitted(): void {
    this.committed.emit()
  }
}
